module.exports = __webpack_public_path__ + "img/banamex.0660cb59.svg";